import Typography from "@mui/material/Typography";

import { useRemoveContactsFromTechnologyQuery } from "@queries/portfolio.query";

import { PopupActions } from "@store/popupStore";

interface IRemoveContacts {
  contactIds: string[];
  technologyId: string;
  technologyName: string;
}

const useRemoveContacts = () => {
  const { mutateAsync: removeContactsFromTechnology } = useRemoveContactsFromTechnologyQuery();
  return ({ contactIds, technologyId, technologyName }: IRemoveContacts) => {
    PopupActions.openConfirmation({
      content: (
        <Typography sx={{ mt: 1 }}>
          Are you sure you would like to remove{" "}
          {contactIds.length > 1 ? `${contactIds.length} contacts` : "this contact"} from{" "}
          <strong>{technologyName}</strong>?
        </Typography>
      ),
      onConfirm: () => {
        void removeContactsFromTechnology({ contactIds, technologyId });
      },
      title: `Remove ${contactIds.length > 1 ? "Contacts" : "Contact"}`,
    });
  };
};

export default useRemoveContacts;
